import { render, staticRenderFns } from "./AvaliacaoPerguntas.vue?vue&type=template&id=5f075737&scoped=true&"
import script from "./AvaliacaoPerguntas.vue?vue&type=script&lang=js&"
export * from "./AvaliacaoPerguntas.vue?vue&type=script&lang=js&"
import style0 from "./AvaliacaoPerguntas.vue?vue&type=style&index=0&id=5f075737&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f075737",
  null
  
)

export default component.exports